/* Theme interactions — built by Accudy. Vanilla JS, no dependencies */
/* Shared helpers (security): always escape text before putting it into HTML,
   and only follow same-origin URLs coming from responses/storage. */
window.__esc = function (str) {
  return String(str == null ? "" : str).replace(/[&<>"'`]/g, function (c) {
    return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;", "`": "&#96;" }[c];
  });
};
window.__safeUrl = function (url) {
  try {
    var u = new URL(url, window.location.origin);
    if (u.origin !== window.location.origin) return null;
    if (u.protocol !== "https:" && u.protocol !== "http:") return null;
    return u.pathname + u.search + u.hash;
  } catch (e) { return null; }
};
window.__toast = function (msg, isError) {
  var t = document.querySelector("[data-toast]");
  if (!t) return;
  t.textContent = msg;
  t.classList.toggle("is-error", !!isError);
  t.hidden = false;
  clearTimeout(window.__toastTimer);
  window.__toastTimer = setTimeout(function () { t.hidden = true; }, 4000);
};
(function () {
  "use strict";

  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Mobile menu ---------- */
  function openMenu() {
    const m = $("[data-menu]"), o = $("[data-menu-overlay]");
    if (m) m.classList.add("is-open");
    if (o) o.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeMenu() {
    const m = $("[data-menu]"), o = $("[data-menu-overlay]");
    if (m) m.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-menu-open]")) { e.preventDefault(); openMenu(); }
    if (e.target.closest("[data-menu-close]")) { e.preventDefault(); closeMenu(); }
    if (e.target.matches("[data-menu-overlay]")) closeMenu();
    const subBtn = e.target.closest("[data-sub-toggle]");
    if (subBtn) {
      const group = subBtn.closest(".mobile-nav__group");
      const sub = $(".mobile-nav__sub", group);
      const open = group.classList.toggle("is-open");
      sub.style.maxHeight = open ? sub.scrollHeight + "px" : 0;
    }
  });

  /* ---------- Cart drawer (delegated; survives AJAX re-render) ---------- */
  function openDrawer() {
    const d = $("[data-drawer]"), o = $("[data-drawer-overlay]");
    if (!d) return;
    d.classList.add("is-open");
    if (o) o.classList.add("is-open");
    document.body.style.overflow = "hidden";
  }
  function closeDrawer() {
    const d = $("[data-drawer]"), o = $("[data-drawer-overlay]");
    if (d) d.classList.remove("is-open");
    if (o) o.classList.remove("is-open");
    document.body.style.overflow = "";
  }
  window.__openCartDrawer = openDrawer;
  document.addEventListener("click", (e) => {
    if (e.target.closest("[data-open-cart]")) { e.preventDefault(); openDrawer(); }
    if (e.target.closest("[data-close-cart]")) { e.preventDefault(); closeDrawer(); }
    if (e.target.matches("[data-drawer-overlay]")) closeDrawer();
  });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeDrawer(); });

  /* ---------- Generic poppers (filter / sort) ---------- */
  $$("[data-popper-toggle]").forEach((btn) => {
    const pop = $("#" + btn.getAttribute("data-popper-toggle"));
    if (!pop) return;
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const willOpen = !pop.classList.contains("is-open");
      $$(".popper.is-open").forEach((p) => p.classList.remove("is-open"));
      pop.classList.toggle("is-open", willOpen);
    });
    pop.addEventListener("click", (e) => e.stopPropagation());
  });
  document.addEventListener("click", () =>
    $$(".popper.is-open").forEach((p) => p.classList.remove("is-open"))
  );

  /* ---------- Collection view switch (2 / 4 / 6) ---------- */
  const grid = $("[data-grid]");
  $$("[data-view-btn]").forEach((btn) => {
    btn.addEventListener("click", () => {
      $$("[data-view-btn]").forEach((b) => b.classList.remove("is-active"));
      btn.classList.add("is-active");
      if (grid) grid.setAttribute("data-view", btn.getAttribute("data-view-btn"));
    });
  });

  /* ---------- Accordions ---------- */
  $$(".accordion__head").forEach((head) => {
    head.addEventListener("click", () => {
      const item = head.closest(".accordion__item");
      const panel = $(".accordion__panel", item);
      const open = item.classList.toggle("is-open");
      panel.style.maxHeight = open ? panel.scrollHeight + "px" : 0;
    });
  });

  /* ---------- Product recommendations (fetch via Shopify API) ---------- */
  $$("[data-recs][data-recs-url]").forEach((wrap) => {
    const url = wrap.getAttribute("data-recs-url");
    if (!url) return;
    fetch(url)
      .then((r) => (r.ok ? r.text() : Promise.reject(r.status)))
      .then((text) => {
        const doc = new DOMParser().parseFromString(text, "text/html");
        const freshRow = doc.querySelector("[data-recs-row]");
        const currentRow = $("[data-recs-row]", wrap);
        // No related products came back → remove the whole block rather than
        // leaving skeletons or an empty heading on the page.
        if (!freshRow || !freshRow.querySelector(".recs__card")) {
          const section = wrap.closest(".shopify-section") || wrap;
          section.remove();
          return;
        }
        if (currentRow) currentRow.innerHTML = freshRow.innerHTML;
        wrap.removeAttribute("data-recs-url");
      })
      .catch(() => {
        // On failure, don't leave skeletons sitting there forever.
        const section = wrap.closest(".shopify-section") || wrap;
        section.remove();
      });
  });

  /* ---------- Material tabs filter colour swatches by material ---------- */
  $$("[data-mat-tabs]").forEach((tabs) => {
    const swatches = $$("[data-swatches] .swatch");
    tabs.querySelectorAll("button").forEach((tab) => {
      tab.addEventListener("click", () => {
        tabs.querySelectorAll("button").forEach((t) => t.classList.remove("is-active"));
        tab.classList.add("is-active");
        const m = (tab.getAttribute("data-material") || "").toLowerCase().trim();
        if (!m) { swatches.forEach((sw) => (sw.style.display = "")); return; }
        // would this filter hide everything? if so, show all (data not tagged)
        const anyMatch = swatches.some((sw) =>
          (sw.dataset.materials || "").toLowerCase().split(/\s+/).includes(m)
        );
        swatches.forEach((sw) => {
          const mats = (sw.dataset.materials || "").toLowerCase().split(/\s+/);
          sw.style.display = (!anyMatch || mats.includes(m)) ? "" : "none";
        });
      });
    });
  });

  /* ---------- Colour swatches ---------- */
  $$("[data-swatches] .swatch").forEach((sw) => {
    sw.addEventListener("click", () => {
      $$("[data-swatches] .swatch").forEach((s) => s.classList.remove("is-active"));
      sw.classList.add("is-active");
      const label = $("[data-swatch-label]");
      if (label && sw.dataset.colour) label.textContent = sw.dataset.colour;
    });
  });

  /* ---------- Read more (PDP description) ---------- */
  $$("[data-readmore]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const target = $("#" + btn.getAttribute("data-readmore"));
      if (!target) return;
      target.hidden = !target.hidden;
      btn.textContent = target.hidden ? "Read more" : "Read less";
    });
  });
})();

/* ============================================================
   ADDED: localization dropdowns + variant image switching
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Localization (EN + country) dropdowns ---------- */
  $$("[data-locale-toggle]").forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.stopPropagation();
      const wrap = btn.closest("[data-locale]");
      const open = wrap.classList.contains("is-open");
      $$("[data-locale].is-open").forEach((w) => w.classList.remove("is-open"));
      if (!open) wrap.classList.add("is-open");
    });
  });
  document.addEventListener("click", () =>
    $$("[data-locale].is-open").forEach((w) => w.classList.remove("is-open"))
  );

  /* ---------- Collection card: swatch swaps card image ---------- */
  $$("[data-card]").forEach((card) => {
    const baseImg = $("[data-card-img]", card);
    const hoverImg = $(".card__media img.is-hover", card);
    const colourLabel = $("[data-card-colour]", card);
    $$("[data-card-swatches] .card__swatch", card).forEach((sw) => {
      sw.addEventListener("click", (e) => {
        e.preventDefault();
        e.stopPropagation();
        const src = sw.getAttribute("data-img");
        // Update BOTH layers: the hover image sits on top while the cursor is
        // over the card, so the base alone would be hidden during the click.
        if (src) {
          if (baseImg) { baseImg.removeAttribute("srcset"); baseImg.src = src; }
          if (hoverImg) { hoverImg.removeAttribute("srcset"); hoverImg.src = src; }
        }
        if (colourLabel && sw.dataset.name) colourLabel.textContent = sw.dataset.name;
        $$("[data-card-swatches] .card__swatch", card).forEach((s) => s.classList.remove("is-active"));
        sw.classList.add("is-active");
      });
    });
  });

  /* ---------- Header search panel ---------- */
  const searchPanel = $("[data-search-panel]");
  const searchToggle = $("[data-search-toggle]");
  const searchInput = $("[data-search-input]");
  function openSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = false;
    if (searchToggle) searchToggle.setAttribute("aria-expanded", "true");
    requestAnimationFrame(() => searchInput && searchInput.focus());
  }
  function closeSearch() {
    if (!searchPanel) return;
    searchPanel.hidden = true;
    if (searchToggle) searchToggle.setAttribute("aria-expanded", "false");
  }
  if (searchToggle) {
    searchToggle.addEventListener("click", (e) => {
      e.stopPropagation();
      searchPanel.hidden ? openSearch() : closeSearch();
    });
  }
  $$("[data-search-close]").forEach((b) => b.addEventListener("click", closeSearch));
  document.addEventListener("keydown", (e) => { if (e.key === "Escape") closeSearch(); });
  if (searchPanel) searchPanel.addEventListener("click", (e) => e.stopPropagation());
  document.addEventListener("click", () => { if (searchPanel && !searchPanel.hidden) closeSearch(); });

  /* ---------- Voice search ---------- */
  (function () {
    const micBtn = $("[data-voice-search]");
    if (!micBtn) return;
    const SR = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SR) { micBtn.hidden = true; return; } // hide on unsupported browsers
    const form = micBtn.closest("form");
    let rec = null, listening = false;
    micBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      if (listening && rec) { rec.stop(); return; }
      rec = new SR();
      rec.lang = document.documentElement.lang || "en-GB";
      rec.interimResults = false;
      rec.maxAlternatives = 1;
      rec.onstart = () => { listening = true; micBtn.classList.add("is-listening"); };
      rec.onend = () => { listening = false; micBtn.classList.remove("is-listening"); };
      rec.onerror = () => { listening = false; micBtn.classList.remove("is-listening"); };
      rec.onresult = (ev) => {
        const text = (ev.results[0][0].transcript || "").trim();
        if (searchInput) { searchInput.value = text; searchInput.focus(); }
        if (text && form) form.submit();
      };
      try { rec.start(); } catch (err) { /* already started */ }
    });
  })();

  /* ---------- Photo / camera search ----------
     With a visual-search endpoint configured: the photo is POSTed there and the
     JSON reply ({url} or {q}) is followed — same-origin URLs only.
     Without one: the photo is analysed in the browser (never uploaded), its
     dominant colour is named and the store is searched for that colour. */
  (function () {
    const camBtn = $("[data-photo-search]");
    const fileInput = $("[data-photo-input]");
    if (!camBtn || !fileInput) return;
    const raw = (camBtn.getAttribute("data-endpoint") || "").trim();
    const endpoint = /^https:\/\//i.test(raw) ? raw : "";
    const searchBase = camBtn.getAttribute("data-search-url") || "/search";

    const COLOURS = [
      ["black", [20, 20, 20]], ["white", [240, 240, 236]], ["cream", [235, 225, 200]],
      ["beige", [210, 190, 160]], ["straw", [215, 185, 120]], ["natural", [200, 175, 140]],
      ["tan", [190, 145, 95]], ["brown", [110, 70, 40]], ["grey", [130, 130, 130]],
      ["navy", [30, 40, 80]], ["blue", [50, 100, 190]], ["green", [60, 120, 70]],
      ["olive", [110, 110, 50]], ["red", [180, 40, 40]], ["burgundy", [110, 25, 40]],
      ["pink", [230, 150, 170]], ["orange", [225, 120, 40]], ["yellow", [235, 200, 60]],
      ["purple", [110, 60, 140]]
    ];
    function nearestColour(r, g, b) {
      let best = COLOURS[0][0], bestD = Infinity;
      COLOURS.forEach(([name, c]) => {
        const d = (r - c[0]) ** 2 * 0.3 + (g - c[1]) ** 2 * 0.59 + (b - c[2]) ** 2 * 0.11;
        if (d < bestD) { bestD = d; best = name; }
      });
      return best;
    }
    function dominantColour(file) {
      return new Promise((resolve, reject) => {
        const url = URL.createObjectURL(file);
        const img = new Image();
        img.onload = () => {
          const size = 64, cv = document.createElement("canvas");
          cv.width = size; cv.height = size;
          const ctx = cv.getContext("2d");
          // centre crop: the product is usually in the middle of the photo
          const m = Math.min(img.width, img.height) * 0.6;
          ctx.drawImage(img, (img.width - m) / 2, (img.height - m) / 2, m, m, 0, 0, size, size);
          const d = ctx.getImageData(0, 0, size, size).data;
          const buckets = {};
          for (let i = 0; i < d.length; i += 4) {
            const key = (d[i] >> 5) + "," + (d[i + 1] >> 5) + "," + (d[i + 2] >> 5);
            const bk = buckets[key] || (buckets[key] = { n: 0, r: 0, g: 0, b: 0 });
            bk.n++; bk.r += d[i]; bk.g += d[i + 1]; bk.b += d[i + 2];
          }
          const top = Object.values(buckets).sort((a, b) => b.n - a.n)[0];
          URL.revokeObjectURL(url);
          resolve(nearestColour(top.r / top.n, top.g / top.n, top.b / top.n));
        };
        img.onerror = () => { URL.revokeObjectURL(url); reject(new Error("image")); };
        img.src = url;
      });
    }
    function go(q) {
      window.location.href = searchBase + "?type=product&q=" + encodeURIComponent(q);
    }

    camBtn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      fileInput.click();
    });
    fileInput.addEventListener("change", async () => {
      const file = fileInput.files && fileInput.files[0];
      if (!file) return;
      if (!/^image\//.test(file.type) || file.size > 15 * 1024 * 1024) {
        window.__toast("Please choose an image under 15 MB.", true);
        fileInput.value = "";
        return;
      }
      camBtn.classList.add("is-busy");
      camBtn.setAttribute("aria-busy", "true");
      try {
        if (endpoint) {
          const fd = new FormData();
          fd.append("image", file);
          const res = await fetch(endpoint, { method: "POST", body: fd, credentials: "omit" });
          const data = await res.json().catch(() => ({}));
          const safe = data && data.url ? window.__safeUrl(data.url) : null;
          if (safe) { window.location.href = safe; return; }
          if (data && typeof data.q === "string" && data.q.trim()) { go(data.q.trim().slice(0, 100)); return; }
        }
        const colour = await dominantColour(file);
        go(colour);
      } catch (err) {
        window.__toast("Photo search couldn’t read that image. Please try another.", true);
      } finally {
        camBtn.classList.remove("is-busy");
        camBtn.removeAttribute("aria-busy");
        fileInput.value = "";
      }
    });
  })();

  /* ---------- PDP: full variant picker (colour swatches + option pills) ---------- */
  const picker = $("[data-variant-picker]");
  if (picker) {
    const jsonEl = $("[data-variant-json]", picker);
    let variants = [];
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) {}

    const mainImg = $("[data-pdp-main]");
    const priceEl = $("[data-pdp-price]");
    const variantInput = $("[data-variant-input]");
    const addBtn = $("[data-add-btn]", picker);
    const addLabel = $("[data-add-label]", picker);

    // selected values keyed by option position (1-based)
    let selected = {};
    try { (JSON.parse(picker.getAttribute("data-current-options")) || []).forEach((v, i) => { selected[i + 1] = v; }); } catch (e) {}

    function swapImage(src) {
      if (!src || !mainImg) return;
      mainImg.style.opacity = "0";
      const pre = new Image();
      pre.onload = () => { mainImg.src = src; mainImg.style.opacity = "1"; };
      pre.src = src;
    }

    function findVariant() {
      return variants.find((v) =>
        Object.keys(selected).every((pos) => v.options[pos - 1] === selected[pos])
      );
    }

    function update() {
      const v = findVariant();
      if (!v) {
        if (addBtn) { addBtn.disabled = true; }
        if (addLabel) addLabel.textContent = "Unavailable";
        return;
      }
      if (variantInput) variantInput.value = v.id;
      if (priceEl) priceEl.textContent = v.price;
      if (v.image) swapImage(v.image);
      if (addBtn) addBtn.disabled = !v.available;
      if (addLabel) addLabel.textContent = v.available ? "Add to cart" : "Sold out";
      document.dispatchEvent(new CustomEvent("variant:change", { detail: { variant: v } }));
      // sync URL
      if (window.history && history.replaceState) {
        try { history.replaceState({}, "", "?variant=" + v.id); } catch (e) {}
      }
    }

    // wire every option control (swatch or pill)
    $$("[data-option-position]", picker).forEach((ctrl) => {
      ctrl.addEventListener("click", () => {
        const pos = ctrl.getAttribute("data-option-position");
        const val = ctrl.getAttribute("data-value");
        selected[pos] = val;

        // active state within this option group
        const group = ctrl.closest("[data-option-group]");
        $$("[data-option-position]", group).forEach((c) => c.classList.remove("is-active"));
        ctrl.classList.add("is-active");

        // update the group's selected label
        const lbl = $('[data-selected-label="' + pos + '"]');
        if (lbl) lbl.textContent = val;

        // immediate image feedback from a colour swatch
        const img = ctrl.getAttribute("data-img");
        if (img) swapImage(img);

        update();
      });
    });
  }
})();

/* ============================================================
   ADDED: AJAX cart (add / change) — no navigation to /cart
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  let qtyBusy = false;
  async function changeLine(key, qty) {
    if (qtyBusy) return;
    qtyBusy = true;
    try {
      await fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ id: key, quantity: qty }),
      });
      if (window.__refreshCartDrawer) { await window.__refreshCartDrawer(false); }
    } finally { qtyBusy = false; }
  }

  /* Delegated quantity steppers — work on the server-rendered drawer AND on
     any drawer markup swapped in later via the Section Rendering API. */
  document.addEventListener("click", (e) => {
    const minus = e.target.closest("[data-qty-minus]");
    const plus = e.target.closest("[data-qty-plus]");
    if (!minus && !plus) return;
    const wrap = (minus || plus).closest("[data-qty]");
    if (!wrap) return;
    const key = wrap.getAttribute("data-line");
    const out = wrap.querySelector("[data-qty-val]");
    let v = parseInt(out.textContent, 10) || 1;
    v = plus ? v + 1 : Math.max(0, v - 1);
    out.textContent = v; // optimistic; server value confirmed on refresh
    if (key) changeLine(key, v);
  });
})();

/* ============================================================
   ADDED: AJAX add-to-cart (no navigation) + drawer refresh
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  function setCartCounts(count) {
    $$("[data-cart-count]").forEach((el) => { el.textContent = count; });
  }

  // Pull a fresh cart drawer via the Section Rendering API and swap it in.
  async function refreshDrawer(openAfter) {
    const wasOpen = !!document.querySelector("[data-drawer].is-open");
    try {
      let html;
      const res = await fetch("/?sections=cart-drawer", { headers: { "Accept": "application/json" } });
      if (res.ok) {
        const data = await res.json();
        html = data["cart-drawer"];
      }
      // Fallback: single-section endpoint returns raw HTML (with the wrapper).
      if (!html) {
        const r2 = await fetch("/?section_id=cart-drawer");
        if (r2.ok) html = await r2.text();
      }
      // Find the drawer's section wrapper WITHOUT relying on its exact id.
      // In a section group the id becomes e.g. shopify-section-sections--xxx__cart-drawer,
      // so we locate it via the [data-drawer] element instead.
      const current = document.querySelector("[data-drawer]");
      const wrap = (current && current.closest(".shopify-section")) ||
                   document.getElementById("shopify-section-cart-drawer");
      if (html && wrap) {
        const tmp = document.createElement("div");
        tmp.innerHTML = html;
        // The response may or may not include the outer .shopify-section wrapper;
        // replace the wrapper's inner content either way so bindings stay delegated.
        const inner = tmp.querySelector(".shopify-section") || tmp;
        wrap.innerHTML = inner.innerHTML;
      }
    } catch (e) { /* drawer markup stays as-is */ }

    // refresh count from cart.js
    try {
      const c = await (await fetch("/cart.js", { headers: { "Accept": "application/json" } })).json();
      setCartCounts(c.item_count);
    } catch (e) {}

    if ((openAfter || wasOpen) && window.__openCartDrawer) window.__openCartDrawer();
  }
  window.__refreshCartDrawer = refreshDrawer;

  // Intercept add-to-cart so it never navigates to /cart.
  document.addEventListener("submit", async (e) => {
    const form = e.target.closest('form[action*="/cart/add"], #addForm');
    if (!form) return;
    e.preventDefault();

    const btn = form.querySelector('[type="submit"]');
    const label = btn ? btn.querySelector("[data-add-label]") || btn : null;
    const prev = label ? label.textContent : "";
    if (btn) btn.disabled = true;
    if (label) label.textContent = "Adding…";

    try {
      const res = await fetch("/cart/add.js", {
        method: "POST",
        headers: { "Accept": "application/json", "X-Requested-With": "XMLHttpRequest" },
        body: new FormData(form),
      });
      if (!res.ok) {
        let msg = "Sorry, that couldn’t be added to your bag.";
        try { const j = await res.json(); if (j && (j.description || j.message)) msg = String(j.description || j.message); } catch (e2) {}
        throw new Error(msg);
      }
      await refreshDrawer(true);
      if (label) label.textContent = "Added";
      setTimeout(() => { if (label) label.textContent = prev || "Add to cart"; }, 1200);
    } catch (err) {
      if (label) label.textContent = prev || "Add to cart";
      if (window.__toast) window.__toast(err && err.message ? err.message : "Something went wrong. Please try again.", true);
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  /* ---------- Sticky header (condense on scroll) ---------- */
  (function () {
    const header = $("[data-header]");
    if (!header || header.getAttribute("data-sticky") === "false") return;
    const wrap = header.parentElement; // the sticky .shopify-section wrapper
    let ticking = false;
    function update() {
      const pinned = wrap ? wrap.getBoundingClientRect().top <= 0 : window.scrollY > 10;
      header.classList.toggle("is-stuck", pinned);
      ticking = false;
    }
    window.addEventListener("scroll", () => {
      if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
    }, { passive: true });
    update();
  })();
})();

/* ============================================================
   ADDED: scroll reveal, featured-collection shelf, cart page
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---------- Scroll reveal (respects reduced motion) ---------- */
  (function () {
    const els = $$("[data-reveal]");
    if (!els.length) return;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches || !("IntersectionObserver" in window)) {
      els.forEach((el) => el.classList.add("is-in"));
      return;
    }
    // Stagger siblings inside a reveal group
    $$("[data-reveal-group]").forEach((group) => {
      $$("[data-reveal]", group).forEach((el, i) => {
        el.style.setProperty("--reveal-delay", Math.min(i * 90, 450) + "ms");
      });
    });
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => {
        if (en.isIntersecting) { en.target.classList.add("is-in"); io.unobserve(en.target); }
      });
    }, { rootMargin: "0px 0px -8% 0px", threshold: 0.06 });
    els.forEach((el) => io.observe(el));
  })();

  /* ---------- Featured collection shelf arrows ---------- */
  $$("[data-shelf]").forEach((shelf) => {
    const track = $("[data-shelf-track]", shelf);
    if (!track) return;
    const prev = $("[data-shelf-prev]", shelf);
    const next = $("[data-shelf-next]", shelf);
    function step() {
      const card = track.firstElementChild;
      return card ? card.getBoundingClientRect().width + 22 : track.clientWidth / 2;
    }
    function sync() {
      const max = track.scrollWidth - track.clientWidth - 4;
      if (prev) prev.toggleAttribute("disabled", track.scrollLeft <= 4);
      if (next) next.toggleAttribute("disabled", track.scrollLeft >= max);
    }
    if (prev) prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    if (next) next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
    track.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    sync();
  })

  /* ---------- Cart page: AJAX quantity / remove / note ---------- */
  ;(function () {
    const page = $("[data-cart-page]");
    if (!page) return;
    const currency = page.getAttribute("data-currency") || "USD";
    let fmt;
    try { fmt = new Intl.NumberFormat(document.documentElement.lang || "en", { style: "currency", currency: currency }); }
    catch (e) { fmt = { format: (n) => currency + " " + n.toFixed(2) }; }
    const money = (cents) => fmt.format(cents / 100);

    let busy = false;
    async function change(key, qty) {
      if (busy) return;
      busy = true;
      page.classList.add("is-busy");
      try {
        const res = await fetch("/cart/change.js", {
          method: "POST",
          headers: { "Content-Type": "application/json", Accept: "application/json" },
          body: JSON.stringify({ id: key, quantity: qty }),
        });
        const cart = await res.json();
        render(cart);
        if (window.__refreshCartDrawer) window.__refreshCartDrawer(false);
      } catch (e) { /* leave DOM as-is */ }
      finally { busy = false; page.classList.remove("is-busy"); }
    }

    function render(cart) {
      if (!cart || typeof cart.item_count !== "number") return;
      if (cart.item_count === 0) { window.location.reload(); return; }
      const keys = cart.items.map((i) => i.key);
      $$("[data-cart-line]", page).forEach((row) => {
        const key = row.getAttribute("data-cart-line");
        const idx = keys.indexOf(key);
        if (idx === -1) { row.remove(); return; }
        const item = cart.items[idx];
        const q = $("[data-qty-val]", row);
        if (q) q.textContent = item.quantity;
        const line = $("[data-line-total]", row);
        if (line) line.textContent = money(item.final_line_price);
        const each = $("[data-line-each]", row);
        if (each) each.textContent = money(item.final_price) + " each";
      });
      const sub = $("[data-cart-page-subtotal]", page);
      if (sub) sub.textContent = money(cart.items_subtotal_price);
      const tot = $("[data-cart-page-total]", page);
      if (tot) tot.textContent = money(cart.total_price);
      const cnt = $("[data-cart-page-count]", page);
      if (cnt) cnt.textContent = "(" + cart.item_count + (cart.item_count === 1 ? " item)" : " items)");
      Array.from(document.querySelectorAll("[data-cart-count]")).forEach((el) => { el.textContent = cart.item_count; });
    }

    page.addEventListener("click", (e) => {
      const minus = e.target.closest("[data-page-qty-minus]");
      const plus = e.target.closest("[data-page-qty-plus]");
      const remove = e.target.closest("[data-line-remove]");
      if (remove) {
        e.preventDefault();
        const row = remove.closest("[data-cart-line]");
        if (row) change(row.getAttribute("data-cart-line"), 0);
        return;
      }
      if (!minus && !plus) return;
      const row = (minus || plus).closest("[data-cart-line]");
      if (!row) return;
      const out = $("[data-qty-val]", row);
      let v = parseInt(out ? out.textContent : "1", 10) || 1;
      v = plus ? v + 1 : Math.max(0, v - 1);
      change(row.getAttribute("data-cart-line"), v);
    });

    // Order note — saved shortly after typing stops
    const note = $("[data-cart-note]", page);
    if (note) {
      let t;
      note.addEventListener("input", () => {
        clearTimeout(t);
        t = setTimeout(() => {
          fetch("/cart/update.js", {
            method: "POST",
            headers: { "Content-Type": "application/json", Accept: "application/json" },
            body: JSON.stringify({ note: note.value }),
          }).catch(() => {});
        }, 600);
      });
    }
  })();
})();

/* ============================================================
   ADDED: INFO & POLICY PAGE INTERACTIONS
   Vanilla, dependency-free. Each block no-ops when absent.
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));
  const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- Reading progress bar ---------- */
  $$("[data-read-progress]").forEach((bar) => {
    const fill = $("span", bar);
    if (!fill) return;
    const update = () => {
      const h = document.documentElement;
      const max = h.scrollHeight - h.clientHeight;
      const pct = max > 0 ? (h.scrollTop / max) * 100 : 0;
      fill.style.width = Math.min(100, Math.max(0, pct)) + "%";
    };
    update();
    window.addEventListener("scroll", update, { passive: true });
    window.addEventListener("resize", update);
  });

  /* ---------- Policy: article accordions (default open) ---------- */
  const policyArticles = $$("[data-policy-article]");
  function setPanel(article, open) {
    const head = $(".policy__art-head", article);
    const panel = $(".policy__art-panel", article);
    if (!head || !panel) return;
    head.setAttribute("aria-expanded", open ? "true" : "false");
    panel.style.maxHeight = open ? panel.scrollHeight + "px" : "0px";
  }
  policyArticles.forEach((article) => {
    setPanel(article, true);
    const head = $(".policy__art-head", article);
    if (head) {
      head.addEventListener("click", () => {
        const open = head.getAttribute("aria-expanded") === "true";
        setPanel(article, !open);
      });
    }
  });
  window.addEventListener("resize", () => {
    policyArticles.forEach((a) => {
      const head = $(".policy__art-head", a);
      if (head && head.getAttribute("aria-expanded") === "true") {
        const panel = $(".policy__art-panel", a);
        if (panel) panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });

  /* ---------- Policy: expand/collapse all ---------- */
  $$("[data-policy-expand]").forEach((btn) => {
    btn.addEventListener("click", () => {
      const anyClosed = policyArticles.some(
        (a) => $(".policy__art-head", a).getAttribute("aria-expanded") === "false"
      );
      policyArticles.forEach((a) => setPanel(a, anyClosed));
      btn.textContent = anyClosed ? "Collapse all" : "Expand all";
    });
  });

  /* ---------- Policy: print ---------- */
  $$("[data-policy-print]").forEach((btn) =>
    btn.addEventListener("click", () => window.print())
  );

  /* ---------- Policy: ToC scroll-spy ---------- */
  const tocLinks = $$("[data-toc-link]");
  if (tocLinks.length && "IntersectionObserver" in window) {
    const linkFor = (id) => tocLinks.find((l) => l.getAttribute("data-toc-link") === id);
    const spy = new IntersectionObserver(
      (entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            tocLinks.forEach((l) => l.classList.remove("is-active"));
            const link = linkFor(e.target.id);
            if (link) link.classList.add("is-active");
          }
        });
      },
      { rootMargin: "-20% 0px -70% 0px", threshold: 0 }
    );
    policyArticles.forEach((a) => spy.observe(a));
  }
  // Smooth-scroll ToC clicks with header offset
  tocLinks.forEach((link) => {
    link.addEventListener("click", (e) => {
      const id = link.getAttribute("data-toc-link");
      const target = document.getElementById(id);
      if (!target) return;
      e.preventDefault();
      const y = target.getBoundingClientRect().top + window.scrollY - 90;
      window.scrollTo({ top: y, behavior: reduce ? "auto" : "smooth" });
    });
  });

  /* ---------- Back-to-top ---------- */
  $$("[data-back-top]").forEach((btn) => {
    const toggle = () => btn.classList.toggle("is-visible", window.scrollY > 600);
    toggle();
    window.addEventListener("scroll", toggle, { passive: true });
    btn.addEventListener("click", () =>
      window.scrollTo({ top: 0, behavior: reduce ? "auto" : "smooth" })
    );
  });

  /* ---------- Generic tab switcher (shipping + care) ---------- */
  function wireTabs(root, tabAttr, panelAttr) {
    $$("[" + tabAttr + "]", root).forEach((tab) => {
      tab.addEventListener("click", () => {
        const id = tab.getAttribute(tabAttr);
        $$("[" + tabAttr + "]", root).forEach((t) => {
          const on = t === tab;
          t.classList.toggle("is-active", on);
          t.setAttribute("aria-selected", on ? "true" : "false");
        });
        $$("[" + panelAttr + "]", root).forEach((p) =>
          p.classList.toggle("is-active", p.id === id)
        );
      });
    });
  }
  $$("[data-ship]").forEach((r) => wireTabs(r, "data-ship-tab", "data-ship-panel"));
  $$("[data-care]").forEach((r) => wireTabs(r, "data-care-tab", "data-care-panel"));

  /* ---------- Shipping: delivery estimator ---------- */
  function addBusinessDays(start, days) {
    const d = new Date(start);
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const day = d.getDay();
      if (day !== 0 && day !== 6) added++;
    }
    return d;
  }
  const fmt = new Intl.DateTimeFormat(document.documentElement.lang || "en-GB", {
    weekday: "short", day: "numeric", month: "short",
  });
  $$("[data-ship-calc]").forEach((calc) => {
    const lead = parseInt(calc.getAttribute("data-lead"), 10) || 3;
    const winEl = $("[data-calc-window]", calc);
    const now = new Date();
    const lower = addBusinessDays(now, Math.max(1, lead - 2));
    const upper = addBusinessDays(now, lead);
    if (winEl) {
      winEl.textContent =
        Math.max(1, lead - 2) === lead
          ? "Arrives " + fmt.format(upper)
          : fmt.format(lower) + " – " + fmt.format(upper);
    }
  });

  /* ---------- Returns: eligibility checker ---------- */
  $$("[data-return-checker]").forEach((box) => {
    const windowDays = parseInt(box.getAttribute("data-window"), 10) || 30;
    const input = $("[data-return-date]", box);
    const btn = $("[data-return-check]", box);
    const out = $("[data-return-verdict]", box);
    if (!input || !btn || !out) return;
    const todayStr = new Date().toISOString().split("T")[0];
    input.max = todayStr;
    function check() {
      out.classList.remove("is-yes", "is-no");
      if (!input.value) {
        out.hidden = false;
        out.innerHTML = "<strong>Please choose your delivery date.</strong>";
        return;
      }
      const delivered = new Date(input.value + "T00:00:00");
      const deadline = new Date(delivered);
      deadline.setDate(deadline.getDate() + windowDays);
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      out.hidden = false;
      if (today <= deadline) {
        const daysLeft = Math.ceil((deadline - today) / 86400000);
        out.classList.add("is-yes");
        out.innerHTML =
          "<strong>Yes — your order is eligible.</strong>You have " +
          daysLeft + " day" + (daysLeft === 1 ? "" : "s") +
          " left to start a return (until " + fmt.format(deadline) + ").";
      } else {
        out.classList.add("is-no");
        out.innerHTML =
          "<strong>This order is outside the " + windowDays +
          "-day window.</strong>Do get in touch — if the item is faulty we'll always help.";
      }
    }
    btn.addEventListener("click", check);
    input.addEventListener("change", check);
  });

  /* ---------- Size guide: unit toggle + calculator ---------- */
  $$("[data-size-calc]").forEach((calc) => {
    const guide = calc.closest("[data-sizeguide]") || document;
    const input = $("[data-size-input]", calc);
    const unitLabel = $("[data-size-unitlabel]", calc);
    const out = $("[data-size-out]", calc);
    const resultEl = $("[data-size-result]", calc);
    const noteEl = $("[data-size-note]", calc);
    const rows = $$("[data-size-row]", guide);
    let unit = "cm";

    function toCm(val) { return unit === "in" ? val * 2.54 : val; }
    function evaluate() {
      const raw = parseFloat(input.value);
      rows.forEach((r) => r.classList.remove("is-match"));
      if (isNaN(raw) || raw <= 0) {
        if (out) out.hidden = true;
        return;
      }
      const cm = toCm(raw);
      let match = null;
      rows.forEach((r) => {
        const min = parseFloat(r.getAttribute("data-min"));
        const max = parseFloat(r.getAttribute("data-max"));
        if (cm >= min - 0.5 && cm <= max + 0.5) match = r;
      });
      // clamp to smallest / largest if out of range
      if (!match && rows.length) {
        const first = rows[0], last = rows[rows.length - 1];
        if (cm < parseFloat(first.getAttribute("data-min"))) match = first;
        else if (cm > parseFloat(last.getAttribute("data-max"))) match = last;
      }
      if (out) out.hidden = false;
      if (match) {
        match.classList.add("is-match");
        if (resultEl) resultEl.textContent = match.getAttribute("data-size");
        if (noteEl) noteEl.textContent = match.getAttribute("data-note") || "";
        if (!reduce) match.scrollIntoView({ block: "nearest", behavior: "smooth" });
      } else if (resultEl) {
        resultEl.textContent = "—";
        if (noteEl) noteEl.textContent = "";
      }
    }
    $$("[data-size-unit]", calc).forEach((btn) => {
      btn.addEventListener("click", () => {
        const next = btn.getAttribute("data-size-unit");
        if (next === unit) return;
        // convert current value to keep it meaningful
        const cur = parseFloat(input.value);
        if (!isNaN(cur)) {
          input.value = next === "in" ? (cur / 2.54).toFixed(1) : (cur * 2.54).toFixed(1);
        }
        unit = next;
        if (unitLabel) unitLabel.textContent = unit;
        $$("[data-size-unit]", calc).forEach((b) =>
          b.classList.toggle("is-active", b === btn)
        );
        evaluate();
      });
    });
    input.addEventListener("input", evaluate);
  });

  /* ---------- FAQ: live search + category filter ---------- */
  $$("[data-faqx]").forEach((root) => {
    const input = $("[data-faqx-input]", root);
    const clearBtn = $("[data-faqx-clear]", root);
    const items = $$("[data-faqx-item]", root);
    const empty = $("[data-faqx-empty]", root);
    const catBtns = $$("[data-faqx-cat]", root);
    let activeCat = "all";

    function apply() {
      const q = (input && input.value || "").trim().toLowerCase();
      if (clearBtn) clearBtn.hidden = !q;
      let visible = 0;
      items.forEach((item) => {
        const text = item.getAttribute("data-text") || "";
        const cat = item.getAttribute("data-cat") || "";
        const matchCat = activeCat === "all" || cat === activeCat;
        const matchText = !q || text.indexOf(q) !== -1;
        const show = matchCat && matchText;
        item.hidden = !show;
        if (show) visible++;
      });
      if (empty) empty.hidden = visible !== 0;
    }
    if (input) input.addEventListener("input", apply);
    if (clearBtn) clearBtn.addEventListener("click", () => {
      if (input) { input.value = ""; input.focus(); }
      apply();
    });
    catBtns.forEach((btn) => {
      btn.addEventListener("click", () => {
        activeCat = btn.getAttribute("data-faqx-cat");
        catBtns.forEach((b) => b.classList.toggle("is-active", b === btn));
        apply();
      });
    });
  });
})();

/* ============================================================
   LOOKBOOK — hotspots, filter, shop-the-look drawer, lightbox
   ============================================================ */
(function () {
  var roots = document.querySelectorAll('[data-lookbook]');
  if (!roots.length) return;

  roots.forEach(function (root) {
    var drawer = root.querySelector('[data-lb-drawer]');
    var drawerList = root.querySelector('[data-lb-drawer-list]');
    var light = root.querySelector('[data-lb-light]');
    var lightImg = root.querySelector('[data-lb-light-img]');

    function closeSpots(except) {
      root.querySelectorAll('.look__spot.is-open').forEach(function (s) {
        if (s !== except) s.classList.remove('is-open');
      });
    }

    /* hotspot popovers */
    root.querySelectorAll('[data-spot]').forEach(function (spot) {
      spot.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = spot.classList.contains('is-open');
        closeSpots(spot);
        spot.classList.toggle('is-open', !open);
      });
    });
    document.addEventListener('click', function () { closeSpots(null); });

    /* category filter */
    var chips = root.querySelectorAll('[data-lb-filter]');
    chips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        chips.forEach(function (c) { c.classList.remove('is-active'); });
        chip.classList.add('is-active');
        var f = chip.getAttribute('data-lb-filter');
        root.querySelectorAll('[data-look]').forEach(function (look) {
          var show = f === '*' || look.getAttribute('data-cat') === f;
          look.classList.toggle('is-hidden', !show);
        });
        closeSpots(null);
      });
    });

    /* shop-the-look drawer */
    function openDrawer(look) {
      if (!drawer || !drawerList) return;
      var items = look.querySelectorAll('[data-spot-pop]');
      var html = '';
      items.forEach(function (pop) {
        var img = pop.querySelector('.look__pop-img img');
        var name = pop.querySelector('.look__pop-name');
        var price = pop.querySelector('.look__pop-price');
        var link = pop.querySelector('.look__pop-link');
        html += '<div class="lb-prod">' +
          (img ? '<div class="lb-prod__img"><img src="' + window.__esc(img.getAttribute('src')) + '" alt=""></div>' : '') +
          '<div><div class="lb-prod__name">' + window.__esc(name ? name.textContent : '') + '</div>' +
          (price ? '<div class="lb-prod__price">' + window.__esc(price.textContent) + '</div>' : '') +
          (link && window.__safeUrl(link.getAttribute('href')) ? '<a class="lb-prod__link" href="' + window.__esc(window.__safeUrl(link.getAttribute('href'))) + '">View product</a>' : '') +
          '</div></div>';
      });
      drawerList.innerHTML = html || '<p style="color:var(--muted);padding:20px 0;">No products tagged on this look yet.</p>';
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeDrawer() {
      if (!drawer) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-shop-look]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        openDrawer(btn.closest('[data-look]'));
      });
    });
    root.querySelectorAll('[data-lb-close]').forEach(function (el) {
      el.addEventListener('click', closeDrawer);
    });

    /* lightbox */
    function openLight(src) {
      if (!light || !lightImg) return;
      lightImg.setAttribute('src', src);
      light.classList.add('is-open');
      light.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }
    function closeLight() {
      if (!light) return;
      light.classList.remove('is-open');
      light.setAttribute('aria-hidden', 'true');
      if (!drawer || !drawer.classList.contains('is-open')) document.body.style.overflow = '';
    }
    root.querySelectorAll('[data-lb-zoom]').forEach(function (img) {
      img.addEventListener('click', function () {
        var big = (img.getAttribute('srcset') || '').split(',').pop().trim().split(' ')[0] || img.getAttribute('src');
        openLight(big);
      });
    });
    if (light) {
      light.querySelectorAll('[data-lb-light-close]').forEach(function (el) { el.addEventListener('click', closeLight); });
      light.addEventListener('click', function (e) { if (e.target === light) closeLight(); });
    }

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { closeDrawer(); closeLight(); closeSpots(null); }
    });
  });
})();

/* ============================================================
   Shop by Style — drag/swipe slider, paged arrows, progress,
   optional autoplay. Re-inits in the theme editor.
   ============================================================ */
(function () {
  "use strict";

  function initSlider(root) {
    if (!root || root.__sbsReady) return;
    var track = root.querySelector("[data-sbs-track]");
    if (!track) return;
    root.__sbsReady = true;

    var prev = root.querySelector("[data-sbs-prev]");
    var next = root.querySelector("[data-sbs-next]");
    var bar = root.querySelector("[data-sbs-bar]");
    var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    function maxScroll() { return track.scrollWidth - track.clientWidth; }
    function pageStep() { return Math.max(track.clientWidth * 0.85, 120); }

    var raf = 0;
    function render() {
      raf = 0;
      var max = maxScroll();
      var x = track.scrollLeft;
      if (bar) {
        var visible = track.scrollWidth > 0 ? track.clientWidth / track.scrollWidth : 1;
        var pct = max > 0 ? x / max : 0;
        var w = Math.min(1, Math.max(0.08, visible));
        bar.style.width = (w * 100) + "%";
        bar.style.left = (pct * (1 - w) * 100) + "%";
      }
      if (prev) prev.disabled = x <= 2;
      if (next) next.disabled = x >= max - 2;
    }
    function schedule() { if (!raf) raf = requestAnimationFrame(render); }

    track.addEventListener("scroll", schedule, { passive: true });
    window.addEventListener("resize", schedule);

    if (prev) prev.addEventListener("click", function () { track.scrollBy({ left: -pageStep(), behavior: reduce ? "auto" : "smooth" }); });
    if (next) next.addEventListener("click", function () { track.scrollBy({ left: pageStep(), behavior: reduce ? "auto" : "smooth" }); });

    /* ---- Drag / swipe to scroll (pointer events) ---- */
    var down = false, startX = 0, startLeft = 0, moved = false;
    track.addEventListener("pointerdown", function (e) {
      if (e.pointerType === "mouse" && e.button !== 0) return;
      down = true; moved = false; startX = e.clientX; startLeft = track.scrollLeft;
      track.classList.add("is-drag");
      try { track.setPointerCapture(e.pointerId); } catch (err) {}
    });
    track.addEventListener("pointermove", function (e) {
      if (!down) return;
      var dx = e.clientX - startX;
      if (Math.abs(dx) > 5) moved = true;
      track.scrollLeft = startLeft - dx;
    });
    function endDrag() {
      if (!down) return;
      down = false;
      track.classList.remove("is-drag");
    }
    track.addEventListener("pointerup", endDrag);
    track.addEventListener("pointercancel", endDrag);
    /* Swallow the click that follows a drag so cards don't navigate mid-swipe. */
    track.addEventListener("click", function (e) {
      if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
    }, true);

    /* ---- Draggable progress bar (click or drag to scrub) ---- */
    var progress = bar ? bar.parentElement : null;
    if (progress) {
      progress.classList.add("is-scrub");
      var scrubbing = false, prevBehavior = "", pRect = null, mx = 0, scrubRaf = 0;
      function applyScrub() {
        scrubRaf = 0;
        if (!pRect || pRect.width <= 0) return;
        var p = (mx - pRect.left) / pRect.width;
        p = Math.max(0, Math.min(1, p));
        track.scrollLeft = p * maxScroll();
      }
      function queueScrub(clientX) {
        mx = clientX;
        if (!scrubRaf) scrubRaf = requestAnimationFrame(applyScrub);
      }
      progress.addEventListener("pointerdown", function (e) {
        if (e.pointerType === "mouse" && e.button !== 0) return;
        scrubbing = true;
        pRect = progress.getBoundingClientRect();
        progress.classList.add("is-active");
        track.classList.add("is-drag");      // disables scroll-snap so scrubbing is smooth
        prevBehavior = track.style.scrollBehavior;
        track.style.scrollBehavior = "auto";
        queueScrub(e.clientX);
        try { progress.setPointerCapture(e.pointerId); } catch (err) {}
        e.preventDefault();
      });
      progress.addEventListener("pointermove", function (e) {
        if (scrubbing) queueScrub(e.clientX);
      });
      function endScrub() {
        if (!scrubbing) return;
        scrubbing = false; pRect = null;
        progress.classList.remove("is-active");
        track.classList.remove("is-drag");
        track.style.scrollBehavior = prevBehavior;
      }
      progress.addEventListener("pointerup", endScrub);
      progress.addEventListener("pointercancel", endScrub);
    }

    /* ---- Optional autoplay ---- */
    if (root.hasAttribute("data-sbs-autoplay") && !reduce) {
      var speed = parseInt(root.getAttribute("data-sbs-speed"), 10) || 5000;
      var timer = null;
      function tick() {
        if (maxScroll() <= 0) return;
        if (track.scrollLeft >= maxScroll() - 2) track.scrollTo({ left: 0, behavior: "smooth" });
        else track.scrollBy({ left: pageStep(), behavior: "smooth" });
      }
      function play() { stop(); timer = setInterval(tick, speed); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }
      ["mouseenter", "focusin", "pointerdown", "touchstart"].forEach(function (ev) { root.addEventListener(ev, stop, { passive: true }); });
      ["mouseleave", "focusout"].forEach(function (ev) { root.addEventListener(ev, play); });
      document.addEventListener("visibilitychange", function () { document.hidden ? stop() : play(); });
      play();
    }

    render();
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-sbs]").forEach(initSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { initAll(); });
  } else {
    initAll();
  }
  /* Theme editor: re-init when this section is added or redrawn. */
  document.addEventListener("shopify:section:load", function (e) { initAll(e.target); });
})();

/* ============================================================
   Conversion features (each guarded so a missing element is a no-op)
   ============================================================ */
(function () {
  "use strict";
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  /* ---- Announcement bar rotator ---- */
  $$("[data-announce]").forEach(function (bar) {
    var msgs = $$("[data-announce-msg]", bar);
    if (msgs.length < 2) return;
    var speed = parseInt(bar.getAttribute("data-speed"), 10) || 4000;
    var i = 0;
    setInterval(function () {
      msgs[i].classList.remove("is-active");
      i = (i + 1) % msgs.length;
      msgs[i].classList.add("is-active");
    }, speed);
  });

  /* ---- Predictive search ---- */
  (function () {
    var box = $("[data-psearch]");
    var input = $("[data-search-input]");
    if (!box || !input) return;
    var base = (box.getAttribute("data-base") || "/").replace(/\/$/, "");
    var timer;
    function hide() { box.hidden = true; box.innerHTML = ""; input.setAttribute("aria-expanded", "false"); }
    function run(q) {
      var url = base + "/search/suggest.json?q=" + encodeURIComponent(q) +
        "&resources[type]=product,collection&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url).then(function (r) { return r.json(); }).then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        var prods = res.products || [], colls = res.collections || [];
        if (!prods.length && !colls.length) { box.innerHTML = '<p class="psearch__empty">No results found.</p>'; box.hidden = false; return; }
        var html = "";
        if (colls.length) {
          html += '<ul class="psearch__cols">' + colls.map(function (c) {
            var cu = window.__safeUrl(c.url); if (!cu) return "";
            return '<li><a href="' + window.__esc(cu) + '">' + window.__esc(c.title) + "</a></li>";
          }).join("") + "</ul>";
        }
        html += '<ul class="psearch__list">' + prods.map(function (p) {
          var pu = window.__safeUrl(p.url); if (!pu) return "";
          var isrc = p.image && /^(https:)?\/\/cdn\.shopify\.com\//.test(p.image) || (p.image && p.image.indexOf("/cdn/shop/") > -1) ? p.image : "";
          var img = isrc ? '<img src="' + window.__esc(isrc) + '" alt="" loading="lazy" width="48" height="48">' : '<span class="psearch__noimg"></span>';
          return '<li><a href="' + window.__esc(pu) + '">' + img + '<span class="psearch__t">' + window.__esc(p.title) + "</span></a></li>";
        }).join("") + "</ul>";
        html += '<a class="psearch__all" href="' + base + '/search?q=' + encodeURIComponent(q) + '">See all results</a>';
        box.innerHTML = html; box.hidden = false; input.setAttribute("aria-expanded", "true");
      }).catch(hide);
    }
    input.addEventListener("input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { hide(); return; }
      timer = setTimeout(function () { run(q); }, 220);
    });
    document.addEventListener("click", function (e) {
      if (!box.contains(e.target) && e.target !== input) box.hidden = true;
    });
  })();

  /* ---- Sticky add-to-cart bar ---- */
  (function () {
    var bar = $("[data-sticky-atc]");
    var form = $("#addForm");
    if (!bar || !form) return;
    var realBtn = $("[data-add-btn]");
    var stickyBtn = $("[data-sticky-add]");
    var label = $("[data-sticky-label]");
    var price = $("[data-sticky-price]");
    var img = $("[data-sticky-img]");
    if (stickyBtn) stickyBtn.addEventListener("click", function () { if (realBtn) realBtn.click(); });
    document.addEventListener("variant:change", function (e) {
      var v = e.detail.variant; if (!v) return;
      if (price && v.price) price.textContent = v.price;
      if (img && v.image) img.src = v.image;
      if (stickyBtn) stickyBtn.disabled = !v.available;
      if (label) label.textContent = v.available ? "Add to cart" : "Sold out";
    });
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var past = e.boundingClientRect.top < 0;
        bar.hidden = !(past && !e.isIntersecting);
      }, { threshold: 0 });
      io.observe(form);
    }
  })();

  /* ---- Back-in-stock toggle ---- */
  (function () {
    var notify = $("[data-notify]");
    var form = $("#addForm");
    if (!notify || !form) return;
    var vField = $("[data-notify-variant]", notify);
    function sync(available, variantTitle) {
      notify.hidden = available;
      form.style.display = available ? "" : "none";
      if (!available && vField && variantTitle) vField.value = variantTitle;
    }
    document.addEventListener("variant:change", function (e) {
      var v = e.detail.variant; if (!v) return;
      sync(v.available, v.options ? v.options.join(" / ") : "");
    });
    // initial state from the real add button
    var btn = $("[data-add-btn]");
    if (btn && btn.disabled && !notify.querySelector(".notify__ok")) sync(false, "");
  })();

  /* ---- Size helper ---- */
  $$("[data-sizehelp]").forEach(function (el) {
    var toggle = $("[data-sizehelp-toggle]", el);
    var panel = $("[data-sizehelp-panel]", el);
    var input = $("[data-sizehelp-input]", el);
    var result = $("[data-sizehelp-result]", el);
    var unitBtns = $$("[data-sizehelp-unit]", el);
    var unit = "cm";
    var ranges = (el.getAttribute("data-ranges") || "").split("\n").map(function (l) {
      var m = l.match(/^(.*?):\s*([\d.]+)\s*-\s*([\d.]+)/);
      return m ? { label: m[1].trim(), min: parseFloat(m[2]), max: parseFloat(m[3]) } : null;
    }).filter(Boolean);
    if (toggle) toggle.addEventListener("click", function () {
      var willOpen = panel.hidden;
      panel.hidden = !willOpen;
      toggle.setAttribute("aria-expanded", willOpen ? "true" : "false");
    });
    unitBtns.forEach(function (b) {
      b.addEventListener("click", function () {
        unit = b.getAttribute("data-sizehelp-unit");
        unitBtns.forEach(function (x) { x.classList.toggle("is-active", x === b); });
        compute();
      });
    });
    if (input) input.addEventListener("input", compute);
    function compute() {
      var val = parseFloat(input.value);
      if (isNaN(val)) { result.textContent = ""; return; }
      var cm = unit === "in" ? val * 2.54 : val;
      var hit = ranges.filter(function (r) { return cm >= r.min && cm <= r.max; })[0];
      if (hit) { result.innerHTML = 'Recommended size: <strong>' + window.__esc(hit.label) + "</strong>"; return; }
      var near = ranges.reduce(function (a, r) {
        return Math.abs((r.min + r.max) / 2 - cm) < Math.abs((a.min + a.max) / 2 - cm) ? r : a;
      }, ranges[0]);
      result.innerHTML = near ? 'Closest size: <strong>' + window.__esc(near.label) + "</strong>" : "";
    }
  });

  /* ---- Recently viewed (localStorage) ---- */
  (function () {
    var KEY = "rv_handles";
    var HANDLE_RE = /^[a-z0-9][a-z0-9\-_]{0,254}$/i;
    function list() {
      try {
        var l = JSON.parse(localStorage.getItem(KEY));
        return Array.isArray(l) ? l.filter(function (h) { return typeof h === "string" && HANDLE_RE.test(h); }) : [];
      } catch (e) { return []; }
    }
    var pdp = $("[data-product-handle]");
    if (pdp) {
      var h = pdp.getAttribute("data-product-handle");
      if (h && HANDLE_RE.test(h)) {
        var l = list().filter(function (x) { return x !== h; });
        l.unshift(h); l = l.slice(0, 12);
        try { localStorage.setItem(KEY, JSON.stringify(l)); } catch (e) {}
      }
    }
    var rv = $("[data-recently-viewed]");
    if (!rv) return;
    var track = $("[data-rv-track]", rv);
    var base = (rv.getAttribute("data-base") || "/").replace(/\/$/, "");
    var current = rv.getAttribute("data-current");
    var limit = parseInt(rv.getAttribute("data-limit"), 10) || 4;
    var handles = list().filter(function (x) { return x && x !== current; }).slice(0, limit);
    if (!handles.length) return;
    Promise.all(handles.map(function (h) {
      return fetch(base + "/products/" + encodeURIComponent(h) + "?section_id=product-card-render")
        .then(function (r) { return r.ok ? r.text() : ""; })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var card = doc.querySelector(".card");
          return card ? '<div>' + card.outerHTML + "</div>" : "";
        }).catch(function () { return ""; });
    })).then(function (parts) {
      var html = parts.filter(Boolean).join("");
      if (!html) return;
      track.innerHTML = html;
      rv.hidden = false;
      if (window.Shopify && Shopify.designMode) {} // no-op
    });
  })();

  /* ---- Newsletter popup ---- */
  $$("[data-npop]").forEach(function (pop) {
    var key = pop.getAttribute("data-key");
    var delay = parseInt(pop.getAttribute("data-delay"), 10);
    if (isNaN(delay)) delay = 6000;
    function seen() { try { return localStorage.getItem(key) === "1"; } catch (e) { return false; } }
    function mark() { try { localStorage.setItem(key, "1"); } catch (e) {} }
    function open() { pop.hidden = false; requestAnimationFrame(function () { pop.classList.add("is-open"); }); }
    function close() { pop.classList.remove("is-open"); mark(); setTimeout(function () { pop.hidden = true; }, 300); }
    $$("[data-npop-close]", pop).forEach(function (b) { b.addEventListener("click", close); });
    document.addEventListener("keydown", function (e) { if (e.key === "Escape" && !pop.hidden) close(); });
    if (pop.querySelector(".npop__ok")) { open(); return; }   // show thank-you after submit
    if (seen()) return;
    if (window.Shopify && Shopify.designMode) { open(); return; } // always preview in editor
    setTimeout(open, delay);
  });
})();


/* ============================================================
   ADDED (v2): collection filters/sort, a11y state, cart-drawer
   gift note, PDP delivery estimate.
   ============================================================ */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---- Filters & sort: submit on change (forms still work without JS) ---- */
  function cleanSubmit(form) {
    // drop empty price inputs so URLs stay clean & canonical-friendly
    $$("input[data-price-input]", form).forEach((i) => { if (i.value === "") i.disabled = true; });
    form.submit();
  }
  $$("[data-facet-form]").forEach((form) => {
    let t;
    form.addEventListener("change", (e) => {
      clearTimeout(t);
      const delay = e.target.matches("[data-price-input]") ? 700 : 0;
      t = setTimeout(() => cleanSubmit(form), delay);
    });
    form.addEventListener("submit", (e) => { e.preventDefault(); cleanSubmit(form); });
  });
  $$("[data-sort-form]").forEach((form) => {
    form.addEventListener("change", () => form.submit());
  });

  /* ---- aria-expanded for poppers + Escape to close ---- */
  document.addEventListener("click", () => {
    requestAnimationFrame(() => {
      $$("[data-popper-toggle]").forEach((btn) => {
        const pop = document.getElementById(btn.getAttribute("data-popper-toggle"));
        btn.setAttribute("aria-expanded", pop && pop.classList.contains("is-open") ? "true" : "false");
      });
      $$(".accordion__item").forEach((item) => {
        const head = $(".accordion__head", item);
        if (head) head.setAttribute("aria-expanded", item.classList.contains("is-open") ? "true" : "false");
      });
    });
  });
  document.addEventListener("keydown", (e) => {
    if (e.key !== "Escape") return;
    $$(".popper.is-open").forEach((p) => p.classList.remove("is-open"));
    $$("[data-popper-toggle]").forEach((b) => b.setAttribute("aria-expanded", "false"));
  });

  /* ---- Cart drawer: gift message / order note (delegated, survives re-render) ---- */
  let noteTimer;
  document.addEventListener("input", (e) => {
    const note = e.target.closest("[data-drawer-note]");
    if (!note) return;
    const status = $("[data-drawer-note-status]");
    clearTimeout(noteTimer);
    if (status) status.textContent = "";
    noteTimer = setTimeout(() => {
      fetch("/cart/update.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ note: note.value.slice(0, 500) }),
      }).then((r) => { if (status) status.textContent = r.ok ? "Saved" : "Couldn’t save"; })
        .catch(() => { if (status) status.textContent = "Couldn’t save"; });
    }, 600);
  });

  /* ---- PDP: live delivery estimate (skips weekends, respects cut-off) ---- */
  $$("[data-delivery-estimate]").forEach((el) => {
    const minD = parseInt(el.getAttribute("data-min"), 10) || 1;
    const maxD = parseInt(el.getAttribute("data-max"), 10) || minD;
    const cutoff = parseInt(el.getAttribute("data-cutoff"), 10);
    const out = $("[data-delivery-dates]", el);
    if (!out) return;
    function addBiz(date, n) {
      const d = new Date(date);
      while (n > 0) { d.setDate(d.getDate() + 1); if (d.getDay() !== 0 && d.getDay() !== 6) n--; }
      return d;
    }
    let start = new Date();
    // Orders after the cut-off hour, or at weekends, dispatch next working day
    if (!isNaN(cutoff) && start.getHours() >= cutoff) start = addBiz(start, 1);
    while (start.getDay() === 0 || start.getDay() === 6) start.setDate(start.getDate() + 1);
    const fmt = new Intl.DateTimeFormat(document.documentElement.lang || "en-GB", { weekday: "short", day: "numeric", month: "short" });
    const a = addBiz(start, minD), b = addBiz(start, maxD);
    out.textContent = minD === maxD ? fmt.format(b) : fmt.format(a) + " – " + fmt.format(b);
    el.hidden = false;
  });
})();
